import { createSlice } from "@reduxjs/toolkit";
import {
  getRanked,
  getOneRanked,
  addRanked,
  updateRanked,
  deleteRanked,
  toggleRankedActive,
} from "./thunk";

const initialState = {
  ranked: [],
  selectedRanked: null,
  loading: false,
  error: null,
  totalPages: 1,
  currentPage: 1,
};

const rankedSlice = createSlice({
  name: "ranked",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ===== GET ALL =====
    builder
      .addCase(getRanked.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRanked.fulfilled, (state, action) => {
        state.loading = false;
        state.ranked = action.payload.data || [];
        state.totalPages =
          action.payload.responseDetails?.pagination?.totalPages || 1;
        state.currentPage =
          action.payload.responseDetails?.pagination?.currentPage || 1;
      })
      .addCase(getRanked.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // ===== GET ONE =====
    builder.addCase(getOneRanked.fulfilled, (state, action) => {
      state.selectedRanked = action.payload;
    });

    // ===== ADD =====
    builder.addCase(addRanked.fulfilled, (state, action) => {
      state.ranked.unshift(action.payload);
    });

    // ===== UPDATE =====
    builder.addCase(updateRanked.fulfilled, (state, action) => {
      const updatedId = action.payload._id;

      state.ranked = state.ranked.map((item) =>
        item._id === updatedId ? { ...item, ...action.payload } : item,
      );
    });

    // ===== DELETE =====
    builder.addCase(deleteRanked.fulfilled, (state, action) => {
      state.ranked = state.ranked.filter(
        (item) => item._id !== action.payload.id,
      );
    });

    // ===== TOGGLE ACTIVE  =====
    builder.addCase(toggleRankedActive.fulfilled, (state, action) => {
      const id = action.payload;

      state.ranked = state.ranked.map((item) => {
        if (item._id === id) {
          return {
            ...item,
            isActive: !item.isActive,
          };
        }
        return item;
      });
    });
  },
});

export default rankedSlice.reducer;
